import { useCallback, useMemo, useRef } from 'react';

import { Messages, MessagesMessage } from 'primereact/messages';

export default function useMessage() {
  const ref = useRef<Messages>(null);

  const showMessage = useCallback((params: MessagesMessage) => {
    const { severity } = params;
    const isError = severity === 'error';

    ref.current?.show({
      closable: false,
      sticky: true,
      summary: isError ? 'Error' : null,
      icon: isError ? 'pi pi-exclamation-triangle' : null,
      ...params,
    });
  }, []);

  const clearMessages = useCallback(() => {
    ref.current?.clear();
  }, []);

  const response = useMemo(
    () => ({
      showMessage,
      elementRef: ref,
      clearMessages,
    }),
    [showMessage, clearMessages]
  );

  return response;
}
